<template>
  <multiselect
    :options="options"
    :searchable="true"
    :internal-search="false"
    :option-height="104"
    :loading="isSearching"
    :options-limit="50"
    :value="author"
    track-by="id"
    label="name"
    placeholder="Επιλέξτε author με χρήση ονόματος..."
    selected-label="Επιλεγμένο"
    select-label="Πατήστε enter για επιλογή"
    deselect-label="Πατήστε enter για απο-επιλογή"
    @search-change="searchAuthors"
    @select="selectAuthor"
    @remove="removeAuthor"
  >
    <template v-slot:option="props" class="option">
      <div class="option__desc">
        <span class="option__title">{{ props.option.name }}</span>
      </div>
    </template>
    <template v-slot:noResult>
      Δε βρέθηκαν αποτελέσματα. Προσπαθήστε ξανά!!
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _debounce from 'lodash/debounce';
import request from '@/utils/request';
import Photo from '@/views/components/Photo';

export default {
  inject: ['$validator'],
  components: {
    Multiselect,
    Photo,
  },
  props: {
    author: Object,
  },
  data() {
    return {
      options: [],
      isSearching: false,
    };
  },
  methods: {
    // eslint-disable-next-line func-names
    searchAuthors: _debounce(async function(searchQuery) {
      if (searchQuery.length) {
        this.isSearching = true;
        const { data } = await request.get('/authors-search', {
          params: {
            term: searchQuery,
          },
        });
        this.isSearching = false;

        this.options = data.authors;
      }
    }, 300),
    selectAuthor(selectedOption) {
      this.$emit('selectAuthor', selectedOption);
    },
    removeAuthor(selectedOption) {
      this.$emit('removeAuthor', selectedOption);
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect {
  margin: 0 auto;
}
</style>
